import { render, staticRenderFns } from "./bookingManifestInfo.vue?vue&type=template&id=18bb2308&scoped=true&"
import script from "./bookingManifestInfo.vue?vue&type=script&lang=js&"
export * from "./bookingManifestInfo.vue?vue&type=script&lang=js&"
import style0 from "./bookingManifestInfo.vue?vue&type=style&index=0&id=18bb2308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bb2308",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18bb2308')) {
      api.createRecord('18bb2308', component.options)
    } else {
      api.reload('18bb2308', component.options)
    }
    module.hot.accept("./bookingManifestInfo.vue?vue&type=template&id=18bb2308&scoped=true&", function () {
      api.rerender('18bb2308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/prePlanBookingJc/bookingManifestInfo.vue"
export default component.exports